var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5V5.55H6.175V3.25L9 0.5L11.825 3.25V9.7H18V19.5H0ZM1.5 18H4.15V15.35H1.5V18ZM1.5 13.85H4.15V11.2H1.5V13.85ZM1.5 9.7H4.15V7.05H1.5V9.7ZM7.675 18H10.325V15.35H7.675V18ZM7.675 13.85H10.325V11.2H7.675V13.85ZM7.675 9.7H10.325V7.05H7.675V9.7ZM7.675 5.55H10.325V2.9H7.675V5.55ZM13.85 18H16.5V15.35H13.85V18ZM13.85 13.85H16.5V11.2H13.85V13.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/Facilities.101b6ead9eedef0fbad24f69e6c47237.svg";
export { ForwardRef as ReactComponent };